// extracted by mini-css-extract-plugin
export default {"duration":"vPmflf"};